module.exports = __webpack_public_path__ + "static/media/abcrunches.2efb3e8a.png";